export default  {
  brooklyn: {
    container: {
      width: 'calc(100% - 10px)'
    },
    button: {
      width: '100%'
    }
  },
  warehouse: {
    positionBlock: '.product-form__payment-container',
    container: {
      width: 'calc(50% - 9px)',
      marginTop: '10px'
    },
    button: {
      width: '100%'
    },
    mobile: {
      container: {
        width: '100%',
        marginTop: '10px'
      },
      button: {
        width: '100%'
      }
    }
  },
  empire: {
    button: {
      float: 'right'
    },
    container: {
      height: '48px'
    }
  },
  narrative: {
    container: {
      marginTop: '10px'
    }
  },
  parallax: {
    container: {
      width: '100%'
    },
  },
  retina: {
    container: {
      width: '100%'
    }
  }
}
